import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    simProviderCreateRequest,
    simProviderEditRequest,
    simProviderGetRequest,
    clearRedux,
} from 'Redux/actions';

const CreateEditSimProvider = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef();

    //Local States
    const [name, setName] = useState('');

    //Redux States
    const {
        openModal,
        loading,
        create,
        update,
        simProvider,
        current,
    } = useSelector(state => state.createEditSimProviderRedux);

    const closeModal = () => {
        setName('');
        dispatch(clearRedux("SIM_PROVIDER_CREATE_EDIT"))
    }

    const applyChanges = () => {
        let payload = {
            name
        }
        if (current?.id) {
            payload.id = current?.id
            dispatch(simProviderEditRequest(payload))
        } else dispatch(simProviderCreateRequest(payload))
    }

    useEffect(() => {
        if (create?.id) {
            NotificationManager.success(
                messages['sim_provider_create_success_message'],
                messages['sim_provider_create_title'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData();
        } else if (create?.error) {
            let message = create?.error

            if (message.includes("name exists already")) {
                message = messages['sim_provider_same_name_exits']
            }

            NotificationManager.error(
                message,
                messages['sim_provider_create_title'],
                3000
            );
            dispatch(clearRedux("SIM_PROVIDER_CREATE_EDIT", { create: null }))
        }

        if (update?.id) {
            NotificationManager.success(
                messages['sim_provider_edit_success_message'],
                messages['sim_provider_edit_title'],
                3000
            );
            
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("SIM_PROVIDER_CREATE_EDIT", { update: null }))
        } else if (update?.error) {
            let message = update?.error

            if (message.includes("name exists already")) {
                message = messages['sim_provider_same_name_exits']
            }

            NotificationManager.error(
                message,
                messages['sim_provider_edit_title'],
                3000
            );
            dispatch(clearRedux("SIM_PROVIDER_CREATE_EDIT", { update: null }))
        }

        if (simProvider) {
            setName(simProvider?.name);
            dispatch(clearRedux("SIM_PROVIDER_CREATE_EDIT", { simProvider: null }))
        }

    }, [create, update, simProvider])

    useEffect(() => {
        if (openModal && current?.id) {
            dispatch(simProviderGetRequest(current?.id))
        }
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={current?.id ? `${messages['sim_provider_edit_title']} (${current?.name})` : messages['sim_provider_create_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div style={{ marginTop: 5 }}>
                            <Input
                                label={messages['sim_provider_name']}
                                placeholder={messages['sim_provider_name']}
                                value={name}
                                onChange={setName}
                                maxLength={25}
                                required
                                requiredMessage={messages['required_field']}
                                formatMessage={messages['common_error_format']}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {
                        formRef?.current?.submit()
                    }}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditSimProvider;